import React, { useEffect } from 'react';
import { Button, Icon, Title } from '@gerdau/hefesto';
import { Table } from '@gerdau/hefesto-mais-web';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { EProjectsMockupsTab } from '../../../..';
import { ApplicationState } from '../../../../../../../store';
import { IFabricationProject } from '../../../../../../../store/ducks/fabrication-projects/types';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../../utils/Tagging';
import DownloadProjectColumn from '../DownloadProjectColumn';
import { Container, ProjectHistoryHeader, TableContainer } from './styles';
export interface IProjectHistoryStateProps {
  project: IFabricationProject;
}

interface IProjectHistoryProps {
  setSelectedTab: (tab: EProjectsMockupsTab) => void;
}

interface IProjectHistoryDataSource {
  key: number;
  projectName: string;
  structures: string[];
  revision: string;
  creationDate: string;
}

const ProjectHistory: React.FC<IProjectHistoryProps> = ({ setSelectedTab }) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { project } = location.state as IProjectHistoryStateProps;

  const projectsState = useSelector(
    (state: ApplicationState) => state.fabricationProjects
  );

  const { pathname } = location;

  const { screenName = '' } = getTaggingInformationScreen(pathname, true);

  const getHistoryProjects = () => {
    const getNextProject = (id: number) => {
      return projectsState.projects?.find((p) => p.nextRevisionId === id);
    };
    let oldRevisionProject = getNextProject(project.id);

    const allHistoryProjects: IFabricationProject[] = [];
    while (oldRevisionProject) {
      allHistoryProjects.push(oldRevisionProject);
      oldRevisionProject = getNextProject(oldRevisionProject.id);
    }
    return allHistoryProjects;
  };

  const historyProjects = getHistoryProjects();

  const data: IProjectHistoryDataSource[] = historyProjects.map(
    (project, idx) => {
      return {
        key: idx,
        projectName: project.fileName,
        structures: project.structures.map((s) => s.name),
        creationDate: project.creationDate,
        revision: project.revision || ' - ',
        action: project
      };
    }
  );

  const getColumns = () => {
    return [
      {
        title: 'Nome do projeto',
        dataIndex: 'projectName',
        sorter: (a: IProjectHistoryDataSource, b: IProjectHistoryDataSource) =>
          a.projectName.localeCompare(b.projectName),
        render: (text: string) => <div>{text ? text : ' - '}</div>
      },
      {
        title: 'Estrutura do projeto',
        dataIndex: 'structures',
        sorter: (a: IProjectHistoryDataSource, b: IProjectHistoryDataSource) =>
          a.structures.toString().localeCompare(b.structures.toString()),
        render: (structures: string[]) => (
          <div>
            {structures.length > 0
              ? structures.map((structure, idx) => <p key={idx}>{structure}</p>)
              : ' - '}
          </div>
        )
      },
      {
        title: 'Revisão',
        dataIndex: 'revision',
        sorter: (a: IProjectHistoryDataSource, b: IProjectHistoryDataSource) =>
          a.revision.localeCompare(b.revision),
        render: (revision: string) => <div>{revision ? revision : ' - '}</div>
      },
      {
        title: 'Data de criação',
        dataIndex: 'creationDate',
        sorter: (a: IProjectHistoryDataSource, b: IProjectHistoryDataSource) =>
          moment(a.creationDate).toDate().getTime() -
          moment(b.creationDate).toDate().getTime(),
        sortDirections: ['descend' as const],
        render: (creationDate: string) => (
          <div>
            {creationDate
              ? moment(creationDate).format('DD/MM/YYYY, hh:mm')
              : ' - '}
          </div>
        )
      },
      {
        title: 'Opções',
        dataIndex: 'action',
        render: (project: IFabricationProject) => (
          <>
            <DownloadProjectColumn
              contractNumber={project.contractNumber}
              projectId={project.id}
              fileName={project.fileName}
            />
          </>
        )
      }
    ];
  };

  useEffect(() => {
    dispatch(
      sendTagging({
        event: 'page_view',
        screenName,
        page: pathname
      })
    );
  }, []);

  return (
    <Container>
      <ProjectHistoryHeader>
        <Button
          name={'backButton'}
          icon={<Icon option="ArrowLeft" />}
          variant="tertiary"
          onClick={() => {
            setSelectedTab(EProjectsMockupsTab.PROJECTS);
            history.goBack();
          }}
        >
          Voltar
        </Button>
        <Title level={1}>Histórico da revisão do projeto</Title>
        <span>{`${project.fileName} - ${project.revision}`}</span>
      </ProjectHistoryHeader>
      <TableContainer>
        <Table columns={getColumns()} dataSource={data}></Table>
      </TableContainer>
    </Container>
  );
};

export default ProjectHistory;
